import { Link, useLocation } from 'react-router-dom'
import { Avatar } from '@/components/common/Avatar'
import { useAuthStore } from '@/store'

/**
 * The avatar in the header: who you are, and the way to your account.
 *
 * A LINK, not a menu. This was a 256px dropdown holding identity, two live
 * switches and four rows — "that little small panel", twice, from Ian. Its
 * contents are now two screens: /account and /notifications/settings.
 *
 * Third time this app has made the same trade. The notifications feed stopped
 * being a dialog inside this menu, the notification switches came out of it,
 * and now the menu itself goes. What each one bought was the same thing: room
 * for the sentence the control needed, and one place to look for a thing
 * instead of a small copy of it in a corner.
 *
 * No unread badge here. The bell beside it carries the count; the same number
 * twice, a centimetre apart, only makes a reader work out whether they are the
 * same number. See NotificationBell.
 */
export function AccountButton() {
  const user = useAuthStore((s) => s.user)
  const { pathname } = useLocation()

  if (!user) return null

  const here = pathname.startsWith('/account')

  return (
    <Link
      to="/account"
      /* h-11/w-11 like the bell: a header control a thumb has to find, and the
         team is on phones almost all of the time. The avatar is drawn smaller
         inside it. */
      className="flex h-11 w-11 items-center justify-center rounded-full transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label={`Account: ${user.firstName} ${user.lastName}`}
      aria-current={here ? 'page' : undefined}
    >
      <Avatar
        person={user}
        size="md"
        /* A ring while you are on the account screen, so the header still says
           where you are — a dropdown used to say that by being open. */
        className={here ? 'ring-2 ring-primary ring-offset-2 ring-offset-card' : undefined}
      />
    </Link>
  )
}
